<script lang="ts" setup>
import { User } from '@vicons/carbon';
import { useAuth } from '../plugin';

const appVersion = import.meta.env.VITE_APP_VERSION;
const { userInfos } = useAuth();
</script>

<template>
  <div
    v-if="userInfos?.sub"

    fixed
    bottom-10px
    right-20px
    z-1
    flex
    items-center
    rounded-lg
    bg-gray-800
    px-2
    py-1
    text-light-500
  >
    <n-icon mr-1>
      <User />
    </n-icon>
    {{
      userInfos
        ? userInfos.name || userInfos.username || userInfos.email || 'Unknown user'
        : 'Unknown user'
    }}
    <span
      v-if="appVersion"
      ml-2
      text-xs
    >[{{ appVersion }}]</span>
  </div>
</template>
